import {
  apiCheckMember,
  apiFavoriteProductList,
  apiFavoriteProductInsert,
  apiFavoriteProductDelete,
  apiGetCourse,
} from "@/api/API.js";

export default {
  data() {
    return {
      favoriteProductIds: [],
      favoriteClassIds: [],
      favoriteClassToProductMap: {},
      favoritePendingMap: {},
    };
  },
  methods: {
    hasFavoriteToken() {
      return (
        this.IsNull(this._sessionData("TokenID")) !== "" ||
        !!localStorage.getItem("NewToken")
      );
    },
    favoriteItemKey(item) {
      return String(item?.ProductId || item?.ClassId || item?.Id || "");
    },
    setFavoritePending(item, value) {
      const key = this.favoriteItemKey(item);
      if (!key) return;
      this.$set(this.favoritePendingMap, key, value);
    },
    isFavoritePending(item) {
      const key = this.favoriteItemKey(item);
      return !!(key && this.favoritePendingMap[key]);
    },
    setFavoriteCollections(list) {
      const productIds = [];
      const classIds = [];
      const classToProductMap = {};

      (list || []).forEach((item) => {
        const productId = item?.ProductId != null ? String(item.ProductId) : "";
        const classId = item?.ClassId != null ? String(item.ClassId) : "";

        if (productId) {
          productIds.push(productId);
        }
        if (classId) {
          classIds.push(classId);
          if (productId) {
            classToProductMap[classId] = productId;
          }
        }
      });

      this.favoriteProductIds = productIds;
      this.favoriteClassIds = classIds;
      this.favoriteClassToProductMap = classToProductMap;
    },
    async loadFavoriteProducts() {
      if (!this.hasFavoriteToken()) {
        this.setFavoriteCollections([]);
        return [];
      }

      try {
        const res = await apiFavoriteProductList({
          Paging: {
            pageNumber: 1,
            pageSize: 9999,
          },
          Search: {},
        });
        const list = Array.isArray(res.data) ? res.data : [];
        this.setFavoriteCollections(list);
        return list;
      } catch (err) {
        console.log(err);
        return [];
      }
    },
    isFavorite(item) {
      const productId = item?.ProductId != null ? String(item.ProductId) : "";
      const classId =
        item?.ClassId != null
          ? String(item.ClassId)
          : item?.Id != null
          ? String(item.Id)
          : "";

      if (productId && this.favoriteProductIds.includes(productId)) {
        return true;
      }

      if (classId && this.favoriteClassIds.includes(classId)) {
        return true;
      }

      return false;
    },
    async resolveFavoriteProductId(item) {
      if (item?.ProductId) {
        return String(item.ProductId);
      }

      const classId = item?.ClassId || item?.Id;
      if (!classId) {
        return "";
      }

      const mapProductId = this.favoriteClassToProductMap[String(classId)];
      if (mapProductId) {
        return String(mapProductId);
      }

      try {
        const res = await apiGetCourse(classId);
        const productId = res.data?.ProductId;
        if (productId) {
          this.$set(
            this.favoriteClassToProductMap,
            String(classId),
            String(productId),
          );
          return String(productId);
        }
      } catch (err) {
        console.log(err);
      }

      return "";
    },
    showFavoriteToast(message, variant = "success") {
      if (this.$bvToast && typeof this.$bvToast.toast === "function") {
        this.$bvToast.toast(message, {
          title: "通知",
          variant,
          solid: true,
          autoHideDelay: 2200,
          toaster: "b-toaster-bottom-left",
        });
        return;
      }

      alert(message);
    },
    favoriteItemName(item) {
      return item?.Title || item?.Name || "";
    },
    openFavoriteLogin(item) {
      this._storeData("LoginFUN", (path2) => {
        if (this.$route.path == path2) {
          this.toggleFavorite(item);
        }
      });
      const openLogin = this._storeData("LoginF1");
      if (this.IsNull(openLogin) !== "") {
        openLogin();
        return;
      }

      this.$root.$emit("bv::show::modal", "signin");
      if (typeof this.FunctionGetImageCode === "function") {
        this.FunctionGetImageCode();
      }
    },
    async ensureFavoriteAuth(item) {
      if (!this.hasFavoriteToken()) {
        this.openFavoriteLogin(item);
        return false;
      }

      try {
        await apiCheckMember();
        return true;
      } catch (err) {
        console.log(err);
        this.openFavoriteLogin(item);
        return false;
      }
    },
    async toggleFavorite(item) {
      if (!item || this.isFavoritePending(item)) {
        return;
      }

      const authed = await this.ensureFavoriteAuth(item);
      if (!authed) {
        return;
      }

      this.setFavoritePending(item, true);

      try {
        const productId = await this.resolveFavoriteProductId(item);
        if (!productId) {
          throw new Error("Favorite product id not found");
        }

        const classId = item?.ClassId || item?.Id || "";

        if (this.isFavorite(item)) {
          await apiFavoriteProductDelete(productId);
          this.favoriteProductIds = this.favoriteProductIds.filter(
            (id) => id !== String(productId),
          );
          if (classId) {
            this.favoriteClassIds = this.favoriteClassIds.filter(
              (id) => id !== String(classId),
            );
            this.$delete(this.favoriteClassToProductMap, String(classId));
          }
          this.showFavoriteToast(
            `${this.favoriteItemName(item) || "此課程"} 已從喜好清單移除`,
            "secondary",
          );
        } else {
          await apiFavoriteProductInsert(productId);
          if (!this.favoriteProductIds.includes(String(productId))) {
            this.favoriteProductIds = [
              ...this.favoriteProductIds,
              String(productId),
            ];
          }
          if (classId && !this.favoriteClassIds.includes(String(classId))) {
            this.favoriteClassIds = [...this.favoriteClassIds, String(classId)];
          }
          if (classId) {
            this.$set(
              this.favoriteClassToProductMap,
              String(classId),
              String(productId),
            );
          }
          this.showFavoriteToast(
            `${this.favoriteItemName(item) || "此課程"} 已加入喜好清單`,
          );
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.setFavoritePending(item, false);
      }
    },
  },
};
